<template>
    <div v-if="showBtnActions">
        <div class="d-flex justify-content-end align-items-center">
            <b-button variant="light" @click="onHandleCloseSection">
                <i class="fa fa-close"></i>
                Cancelar
            </b-button>
            <b-button variant="outline-danger" class="ml-1" @click="removeItem">
                <i class="fa fa-trash"></i>
                Eliminar
            </b-button>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    name: 'ActionButtons',
    
    props: {
        showBtnActions: {
            type: Boolean,
            default: true,
            required: false
        }
    },

    computed: {
        ...mapState('labelDesigner', [
            'activeSection',
            'selectedLayout'
        ])
    },

    methods: {
        ...mapMutations('labelDesigner', [
            'setSelectedLayout',
            'setActiveSection',
            'setSectionSelected'
        ]),

        removeItem() {
            this.setSelectedLayout({
                ...this.selectedLayout,
                layout: this.selectedLayout.layout.filter(
                    (i) => i.id !== this.activeSection.id
                ),
            })

            this.setActiveSection(null);
            this.setSectionSelected(null)
        },

        onHandleCloseSection() {
            this.setActiveSection(null);
        }
    }
}
</script> 